import { render, staticRenderFns } from "./AppHeader.vue?vue&type=template&id=6bfaa06b&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=ts"
export * from "./AppHeader.vue?vue&type=script&lang=ts"
import style0 from "./AppHeader.vue?vue&type=style&index=0&id=6bfaa06b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfaa06b",
  null
  
)

export default component.exports